<template>
  <div>
    <div class="page-content border-bottom">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="searchInfo" class="demo-form-inline">
          <el-form-item label="日期">
            <el-date-picker
              @change="handleChangeDatePicker"
              v-model="datePickerVal"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy/MM/dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00','23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="searchInfo.memTel" placeholder="请输入会员手机号" class="form-item-width" clearable></el-input>
          </el-form-item>
          <el-form-item class="right-btns">
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 表格展示区域 -->
    <div class="page-content margin-top">
      <!-- 表格组件 -->
      <el-table
        :data="tableData"
        stripe
        style="width: 100%" border
        :header-cell-style="{ background: '#eef1f6', color: '#606266','text-align':'center' }"
        :cell-style="{'text-align':'center'}" height="66vh" scroll-y
      >
        <!-- 循环展示表格 -->
        <el-table-column
          v-for="tab in tableTitle"
          :key="tab.code"
          :label="tab.name"
          show-overflow-tooltip
          :width="tab.width"
        >
          <template slot-scope="scope">
            <span>{{ scope.row[tab.code] }} </span>
          </template>
        </el-table-column>
       
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination
          :total="dataTotal"
          :page="searchInfo.page"
          :limit="searchInfo.limit"
          @pagination="onChangePages"
        />
      </div>
    </div>

    
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { getMonthReport } from '@/api/forms.js'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      // 日期时间
      datePickerVal: [new Date(new Date().setDate(new Date().getDate()-30)).toLocaleString(),new Date().toLocaleString()],
      // 查询数据
      searchInfo: {
        startTime: '',
        endTime: '',
        memTel: '',
        page: 1,
        size: 20,
      },
      // 表格数据
      tableData: [],
      // 数据总数
      dataTotal: 100,
      // 表格标题数组
      tableTitle: [
        { name: '会员号', code: 'memNo', width: '' },
        { name: '手机号', code: 'memTel', width: '' },
        { name: '会员姓名', code: 'memRealName', width: '' },
        { name: '积分数量', code: 'pointsCount', width: '' },
        { name: '充电度数', code: 'chargeDegree', width: '' },
        { name: '充电次数', code: 'chargeCount', width: '' },
        { name: '核销积分', code: 'checkCount', width: '' },
      ],
    }
  },
  mounted() {
    // 查询数据
    this.searchInfo.startTime = this.datePickerVal[0]
    this.searchInfo.endTime = this.datePickerVal[1]
    this.onSearch()
  },
  methods: {
    // 查询
    onSearch() {
      this.searchInfo.page = 1
      this.onGetDataList()
    },
    // 获取列表
    async onGetDataList() {
      const data = await getMonthReport(this.searchInfo)
      this.tableData = data.data.records
      this.dataTotal = data.data.total
    },
    // 修改日期框
    handleChangeDatePicker(e) {
      this.searchInfo.startTime = e[0]
      this.searchInfo.endTime = e[1]
    },
    // 重置
    onReset() {
      this.datePickerVal = [new Date(new Date().setDate(new Date().getDate()-30)).toLocaleString(),new Date().toLocaleString() ]
      this.searchInfo.startTime = this.datePickerVal[0]
      this.searchInfo.endTime = this.datePickerVal[1]
      this.searchInfo.memTel = ''
      this.onSearch()
    },
    // 分页方法
    onChangePages(pageInfo) {
      const { page, limit } = pageInfo
      this.searchInfo.page = page
      this.searchInfo.size = limit
      this.onGetDataList()
    },
   
  },
}
</script>

<style lang="less" scoped>
.form-item-width {
  width: 250px;
}
.right-btns {
  position: absolute;
  right: 20px !important;
}
.el-form-item {
  font-weight: bold;
  margin: 0 20px 4px 10px !important;
}
.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}
.margin-top {
  margin-top: -15px;
}


</style>